import React from 'react';
import { motion } from 'framer-motion';
import '../../assets/styles/HomePage.css';
import ServicesSection from './ServicesSection';
import AboutUsSection from './AboutUsSection';
import CallToActionSection from './CallToActionSection';
import FAQSection from './FAQSection';
import PortfolioSection from './PortfolioSection';
import ProcessSection from './ProcessSection';
import PackagesSection from './PackagesSection';

import heroShot from '../../assets/images/pureseatcomfort-ss1.png';

const HeroVisual = () => (
  <div className="hero-cards">
    {/* Stat card — satisfaction */}
    <motion.div
      className="hero-card hero-card--stat"
      initial={{ opacity: 0, y: 20, rotate: -4 }}
      animate={{ opacity: 1, y: 0, rotate: -4 }}
      transition={{ duration: 0.6, delay: 0.4 }}
    >
      <span className="hero-card-number">100%</span>
      <span className="hero-card-label">Customer satisfaction</span>
    </motion.div>

    {/* Stat card — delivery */}
    <motion.div
      className="hero-card hero-card--stat hero-card--delivery"
      initial={{ opacity: 0, y: 20, rotate: 3 }}
      animate={{ opacity: 1, y: 0, rotate: 3 }}
      transition={{ duration: 0.6, delay: 0.55 }}
    >
      <span className="hero-card-number">4 wks</span>
      <span className="hero-card-label">Avg. delivery time</span>
    </motion.div>

    {/* Portfolio thumbnail card */}
    <motion.div
      className="hero-card hero-card--shot"
      initial={{ opacity: 0, y: 24, rotate: -2 }}
      animate={{ opacity: 1, y: 0, rotate: -2 }}
      transition={{ duration: 0.6, delay: 0.7 }}
    >
      <div className="hero-card-browser">
        <div className="browser-dots">
          <span /><span /><span />
        </div>
        <img src={heroShot} alt="Portfolio site preview" />
      </div>
      <span className="hero-card-url">pureseatcomfort.com</span>
    </motion.div>
  </div>
);

const HomePage = () => (
  <div className="homepage">

    <section className="nxlw-hero">
      <div className="nxlw-hero-inner split">

        {/* Left — copy */}
        <motion.div
          className="nxlw-hero-copy"
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          <p className="eyebrow">Web design agency</p>
          <h1>
            Taking your business<br />
            <span>to the Next Level</span>
          </h1>
          <p className="hero-support">
            Custom websites that drive results — crafted for growth, designed for trust.
          </p>
          <div className="cta-row">
            <a href="/get-started" className="btn-accent">Let's work together</a>
            <a href="#portfolio" className="btn-secondary">View portfolio</a>
          </div>
        </motion.div>

        {/* Right — visual cards */}
        <HeroVisual />

      </div>
    </section>

    <AboutUsSection />
    <ServicesSection />
    <ProcessSection />
    <PortfolioSection />
    <PackagesSection />
    <CallToActionSection />
    <FAQSection />

  </div>
);

export default HomePage;
